import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  async submit(event) {
    event.preventDefault()

    const form = this.element
    const submitButton = form.querySelector('[type="submit"]')
    const url = new URL(form.action)
    new URLSearchParams(new FormData(form)).forEach((value, key) => {
      url.searchParams.set(key, value)
    })

    const originalLabel = submitButton?.innerHTML
    if (submitButton) {
      submitButton.innerHTML = '<i class="fa fa-spin fa-spinner"></i>'
      submitButton.disabled = true
    }

    try {
      const response = await fetch(url.toString(), {
        headers: { Accept: "text/vnd.turbo-stream.html" },
      })

      if (response.ok) {
        history.pushState({}, "", url.toString())
        const text = await response.text()
        Turbo.renderStreamMessage(text)
        document.dispatchEvent(new CustomEvent("turbo:submit-end", { bubbles: true }))
      } else {
        console.error("Search failed:", response.status, response.statusText)
        this.#showNetworkError()
      }
    } catch (error) {
      console.error("Search error:", error)
      this.#showNetworkError()
    } finally {
      if (submitButton) {
        submitButton.innerHTML = originalLabel
        submitButton.disabled = false
      }
    }
  }

  #showNetworkError() {
    const container = document.getElementById("siem-flash-messages")
    if (!container) return
    container.insertAdjacentHTML(
      "afterbegin",
      `<div class="alert alert-dismissible animated fadeIn alert-danger">
        <button class="close" data-dismiss="alert">×</button>
        <span>Search failed. Please try again or contact support if the problem persists.</span>
      </div>`
    )
  }
}
